import { Skeleton } from 'shared/src/components/ui/new/Skeleton';

const ROWS = ['first', 'second', 'third', 'fourth', 'fifth'];

export function FilterPanelSkeleton() {
  return (
    <div className="space-y-2 p-2">
      {ROWS.map((row) => (
        <Skeleton key={row} className="h-5 w-full" />
      ))}
    </div>
  );
}
